export default __webpack_public_path__ + "static/media/001-new-product.c27325c1.svg";